/** Detect whether a QDF/training draft payload has meaningful instructor-entered content. */

function hasText(value) {
  return typeof value === "string" && value.trim().length > 0;
}

function assessmentsHaveContent(assessments) {
  if (!Array.isArray(assessments)) return false;
  return assessments.some((a) => {
    if (!a || typeof a !== "object") return false;
    if (a.score != null && a.score !== "") return true;
    if (hasText(a.private_note) || hasText(a.note)) return true;
    return false;
  });
}

export function draftPayloadHasMeaningfulContent(payload) {
  if (!payload || typeof payload !== "object") return false;
  if (
    hasText(payload.strengths) ||
    hasText(payload.areas_for_improvement) ||
    hasText(payload.next_session_focus) ||
    hasText(payload.instructor_notes_private) ||
    hasText(payload.learner_visible_notes) ||
    hasText(payload.lesson_focus) ||
    hasText(payload.recommendations)
  ) {
    return true;
  }
  if (assessmentsHaveContent(payload.daily_task_assessments)) return true;
  if (assessmentsHaveContent(payload.custom_category_assessments)) return true;
  if (assessmentsHaveContent(payload.competency_assessments)) return true;
  if (Array.isArray(payload.quick_lesson_tasks) && payload.quick_lesson_tasks.length > 0) return true;
  if (Array.isArray(payload.hazard_observations) && payload.hazard_observations.some(hasText)) return true;
  if (Array.isArray(payload.skills_practised) && payload.skills_practised.length > 0) return true;
  return false;
}

export function qdfFormHasMeaningfulContent({ form, taskState, customCategoryState, dailyTasks, activeCustomCategories, selectedTasks, tab }) {
  const payload = {
    strengths: form?.strengths,
    areas_for_improvement: form?.areas_for_improvement,
    next_session_focus: form?.next_session_focus,
    instructor_notes_private: form?.instructor_notes_private,
    hazard_observations: form?.hazard_note ? [form.hazard_note] : [],
    quick_lesson_tasks: tab === "QUICK_LESSON" ? selectedTasks || [] : [],
    daily_task_assessments: tab === "QUICK_DAILY_FEEDBACK" ? Object.entries(taskState || {}).map(([task_id, row]) => ({
      task_id,
      score: row?.score,
      private_note: row?.private_note,
    })) : [],
    custom_category_assessments: tab === "QUICK_DAILY_FEEDBACK"
      ? Object.entries(customCategoryState || {}).map(([category_id, row]) => ({
          category_id,
          score: row?.score,
          private_note: row?.private_note,
        }))
      : [],
  };
  return draftPayloadHasMeaningfulContent(payload);
}
